import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ConfirmComponent } from 'src/app/confirm/confirm.component';
import { Globals } from '../../globals';

@Component({
  selector: 'app-modal-carrito-productos',
  templateUrl: './modal-carrito-productos.component.html',
  styleUrls: ['./modal-carrito-productos.component.scss']
})
export class ModalCarritoProductosComponent implements OnInit {

  constructor(
		public globals: Globals,
    private dialog: MatDialog,
    private router: Router,

  ) { }

  formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  cancelarCotizacion(){
    const dialogRef = this.dialog.open(ConfirmComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // El usuario confirmó, ejecuta la acción
        this.globals.configuracion.front.cart.cotizacion_id = "";
        this.globals.configuracion.front.cart.productos.splice( 0 );
    
        this.globals.configuracion.front.cart.total = this.formatter.format( 0 );
    
        this.globals.setDataFront();
        this.dialog.open(ModalCarritoProductosComponent, {
          autoFocus: false, 
          width: '600px',
          maxWidth: '100%'
        });
      } else {
        // El usuario canceló, no hagas nada
        this.dialog.open(ModalCarritoProductosComponent, {
          autoFocus: false, 
          width: '600px',
          maxWidth: '100%'
        });
      }
    })
  }
  
  ngOnInit(): void {
  }

}
